import { render, staticRenderFns } from "./logisticsEmission.vue?vue&type=template&id=53985307&scoped=true&"
import script from "./logisticsEmission.vue?vue&type=script&lang=js&"
export * from "./logisticsEmission.vue?vue&type=script&lang=js&"
import style0 from "./logisticsEmission.vue?vue&type=style&index=0&id=53985307&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53985307",
  null
  
)

export default component.exports